import { z } from 'zod';

// TODO: вернуть ACCREDITATION_STAGE_CHANGED, когда бэкенд добавит тип в NoticeType
// и логику отправки уведомлений о смене стадии аккредитации
// import {
//   accreditationStageChangedNotificationSchema,
//   accreditationStageChangedNotificationType,
// } from './AccreditationStageChangedNotification';
import { fixationPeriodNotificationSchema, fixationPeriodNotificationType } from './FixationPeriodNotification';
import { otherNotificationSchema, otherNotificationType } from './OtherNotification';

export const notificationType = z.enum([
  fixationPeriodNotificationType.value,
  // accreditationStageChangedNotificationType.value,
  otherNotificationType.value,
]);

export type NotificationType = z.output<typeof notificationType>;

export const notificationsTypeTextsMap: Record<NotificationType, string> = {
  LEAD_EXP: 'Истечение срока фиксации',
  // ACCREDITATION_STAGE_CHANGED: 'Аккредитация',
  OTHER: 'Другое',
};

export const notificationSchema = z.union([
  otherNotificationSchema,
  fixationPeriodNotificationSchema,
  // accreditationStageChangedNotificationSchema,
]);

export type NotificationEntityApi = z.input<typeof notificationSchema>;

export type NotificationEntity = z.infer<typeof notificationSchema>;
